<mat-progress-bar class="d-block" mode="indeterminate" *ngIf="loading$ | async"></mat-progress-bar>
<div *ngIf="!(loading$|async)">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding ngClass="final">
            <div class="item">
                <div>
                    <ng-container *ngIf="node.icon">
                        <mat-icon *ngIf="!iconos.esSvg(node.icon); else svgHoja">{{ node.icon }}</mat-icon>
                        <ng-template #svgHoja>
                            <mat-icon [svgIcon]="iconos.svgIcono(node.icon)"></mat-icon>
                        </ng-template>
                    </ng-container>
                    <span>{{node.text}}</span>
                </div>
                <div>
                    <mat-icon>grade</mat-icon>
                    <span>{{node.requiredRole}}</span>
                </div>
                <div>
                    <mat-icon>link</mat-icon>
                    <span>{{node.link}}</span>
                </div>
                <div class="separator"></div>
                <button mat-icon-button color="primary" (click)="add(node)">
                    <mat-icon>add</mat-icon>
                </button>
                <button mat-icon-button (click)="move(node, -1)">
                    <mat-icon>keyboard_arrow_up</mat-icon>
                </button>
                <button mat-icon-button (click)="move(node, +1)">
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                <button mat-icon-button color="primary" (click)="edit(node)">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="remove(node)">
                    <mat-icon>delete_forever</mat-icon>
                </button>
            </div>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
            <div class="group">
                <button mat-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.text" class="group-button"
                        color="primary">
                    <mat-icon class="mat-icon-rtl-mirror" *ngIf="!iconos.esSvg(node.icon); else svgGrupo">
                        {{ node.icon ? node.icon : (treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right') }}
                    </mat-icon>
                    <ng-template #svgGrupo>
                        <mat-icon class="mat-icon-rtl-mirror" [svgIcon]="iconos.svgIcono(node.icon)"></mat-icon>
                    </ng-template>
                    &nbsp; {{node.text}} [{{node.requiredRole}}]
                </button>
                <button mat-icon-button color="primary" (click)="add(node)">
                    <mat-icon>add</mat-icon>
                </button>
                <button mat-icon-button (click)="move(node, -1)">
                    <mat-icon>keyboard_arrow_up</mat-icon>
                </button>
                <button mat-icon-button (click)="move(node, +1)">
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                <button mat-icon-button color="primary" (click)="edit(node)">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="remove(node)">
                    <mat-icon>delete_forever</mat-icon>
                </button>
            </div>
        </mat-tree-node>
    </mat-tree>
    <button mat-raised-button class="add-btn" color="primary" (click)="add(null)">
        <mat-icon>add</mat-icon>
        Nuevo
    </button>
</div>

<ng-template #deletionConfirmation>
    <form [formGroup]="templateForm" autocomplete="off">
        <be-dialog-shell title="Editar item" (close)="cancelEdition()">
            <mat-form-field>
                <mat-label>Icono</mat-label>
                <input matInput type="text" formControlName="icon">
            </mat-form-field> &nbsp;
            <mat-form-field>
                <mat-label>Nombre</mat-label>
                <input matInput type="text" formControlName="name" required>
            </mat-form-field> &nbsp;
            <mat-form-field>
                <mat-label>Rol requerido</mat-label>
                <input matInput type="text" formControlName="role" required>
            </mat-form-field> &nbsp;
            <mat-form-field [style.visibility]="linkEditable?'visible':'hidden'">
                <mat-label>Link</mat-label>
                <mat-select translate="no" formControlName="link" [required]="linkRequerido">
                    <mat-option translate="no" *ngFor="let ruta of rutasAplicacion" [value]="ruta">
                        {{ruta !== '' ? ruta : '-- Origen --'}}
                    </mat-option>
                </mat-select>
            </mat-form-field> &nbsp;
            <mat-form-field [style.visibility]="linkEditable?'visible':'hidden'">
                <mat-label>Parametros</mat-label>
                <input matInput type="text" formControlName="queryParams">
            </mat-form-field> &nbsp;

            <dialog-actions>
                <button mat-flat-button color="accent" (click)="cancelEdition()">Cancelar</button>
                <button mat-flat-button color="primary" (click)="acceptEdition()" [disabled]="templateForm.invalid">
                    Aceptar
                </button>
            </dialog-actions>
        </be-dialog-shell>
    </form>
</ng-template>
